import { render, staticRenderFns } from "./OtherIdsEditPanel.vue?vue&type=template&id=36fd2d4a"
import script from "./OtherIdsEditPanel.vue?vue&type=script&lang=js"
export * from "./OtherIdsEditPanel.vue?vue&type=script&lang=js"
import style0 from "./OtherIdsEditPanel.vue?vue&type=style&index=0&id=36fd2d4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports